<template>
  <div id="dashboard" class="content">
    <div class="row push mb-0" v-show="false">
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ newUserArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#82b54b"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#82b54b"
                data-highlight-line-color="#82b54b"
                data-tooltip-suffix="人"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{userNum.newUser || 0}}</p>
              <p class="text-muted mb-0 font-size-75">新增用户数</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ buyUserArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#e04f1a"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#e04f1a"
                data-highlight-line-color="#e04f1a"
                data-tooltip-suffix="人"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{userNum.buyUser|| 0}}</p>
              <p class="text-muted mb-0 font-size-75">付费用户数</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ totalUserArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#3c90df"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#3c90df"
                data-highlight-line-color="#3c90df"
                data-tooltip-suffix="人"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{userNum.totalUser || 0}}</p>
              <p class="text-muted mb-0 font-size-75">总用户数(人)</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-md-6 col-xl-3">
        <a class="block block-rounded cursor-auto" href="javascript:void(0)">
          <div
            class="block-content block-content-full d-flex align-items-center justify-content-between"
          >
            <div>
              <span
                class="js-sparkline"
                data-type="line"
                :data-points="'['+ arpuIncomeArr+']'"
                data-width="90px"
                data-height="40px"
                data-line-color="#343a40"
                data-fill-color="transparent"
                data-spot-color="transparent"
                data-min-spot-color="transparent"
                data-max-spot-color="transparent"
                data-highlight-spot-color="#343a40"
                data-highlight-line-color="#343a40"
                data-tooltip-suffix="元"
              >
                <canvas
                  width="90"
                  height="40"
                  style="display: inline-block; width: 90px; height: 40px; vertical-align: top;"
                ></canvas>
              </span>
            </div>
            <div class="ml-3 text-right">
              <p class="font-size-h3 font-w300 mb-0">{{userNum.arpuIncome || 0}}</p>
              <p class="text-muted mb-0 font-size-75">总人均收入(ARPU)</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div id="dashboard">
      <div class="block block-rounded block-bordered">
        <ul
          class="nav nav-tabs nav-tabs-block nav-main nav-main-horizontal nav-main-hover"
          data-toggle="tabs"
          role="tablist"
        >
          <li class="nav-item" v-for="(item,index) in bis" :key="index">
            <a
              class="nav-link"
              :class="['btabs-animated-fade-'+item.BIS_TYPE ,
              [bis.length>1&&(item.BIS_TYPE==bisType||index==0)?'active':''],
             [bis.length==1?' oneTable':'']]"
              v-if="(item.BIS_TYPE == 1 && isAllPageTabs) || (item.BIS_TYPE == 2 && isWhitePageTabs) || item.BIS_TYPE == 3 || item.BIS_TYPE == 4"
              href="javascript:void(0)"
              @click="showTab('btabs-animated-fade-'+item.BIS_TYPE,item.BIS_TYPE)"
            >{{item.BIS_NAME}}</a>
          </li>

          <li class="ml-auto nav-main-item add" v-if="!addBtn "></li>
          <li class="ml-auto nav-main-item" v-if="addBtn " style="margin-top:6px">
            <a
              class="nav-main-link"
              data-toggle="submenu"
              aria-haspopup="true"
              aria-expanded="false"
              href="#"
            >
              <button type="button" class="btn-block-option add-btn mr-2" data-toggle="modal" v-if="addBtn"
                @click="create('user')">
                <i class="fa fa-plus mr-1"></i> 新增
              </button>
            </a>
            <!-- <ul class="nav-main-submenu">
              <li
                class="nav-main-item"
                data-toggle="modal"
                v-if="addBtn"
                @click="create('user')"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">用户</span>
                </a>
              </li>
              <li
                class="nav-main-item"
                data-toggle="modal"
                v-if="addBtn"
                @click="create('card')"
              >
                <a class="nav-main-link" href="javascript:void(0)">
                  <span class="nav-main-link-name">实体卡</span>
                </a>
              </li>
            </ul> -->
          </li>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
            style="margin-right: 1.25rem"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </ul>
        <div class="block-content tab-content overflow-hidden">
          <div
            class="tab-pane fade"
            id="btabs-animated-fade-1"
            role="tabpanel"
            :class="{'show active':isAllPageTabs}"
            v-show="isAllPageTabs"
          >
            <all ref="all"></all>
          </div>
          <div
            class="tab-pane fade"
            id="btabs-animated-fade-2"
            role="tabpanel"
            :class="{'show active':!isAllPageTabs&&isWhitePageTabs}"
            v-show="isWhitePageTabs"
          >
            <white ref="white"></white>
          </div>
          <div
            class="tab-pane fade"
            id="btabs-animated-fade-3"
            role="tabpanel"
          >
            <cardUser ref="cardUser"></cardUser>
          </div>
          <div
            class="tab-pane fade"
            id="btabs-animated-fade-4"
            role="tabpanel"
          >
            <ontimeUser ref="ontimeUser"></ontimeUser>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增用户 -->
    <div
      class="modal fade"
      id="modal-default-normal-all-add"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">新增用户</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  新增方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="cell-auth-type"
                    name="cell-auth-type"
                    v-model="form.type"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in addTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  手机号码
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.mobilePhone"
                    maxlength="11"
                    :disabled="form.type!='1'&&form.type!='2'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required" v-if="form.type == 2">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.userCard"
                    :disabled="form.type!='2'"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增实体卡 -->
    <div
      class="modal fade"
      id="modal-default-normal-card"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-normal-card"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
            >新增实体卡</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="10"
                    v-model="form.cardNo"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">关联方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    id="bill-type"
                    name="bill-type"
                    v-model="form.relationType"
                    @change="changeType()"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in typeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">关联用户ID
                  <span class="input-required" v-show="form.relationType=='1' || form.relationType=='3'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    :disabled="!(form.relationType=='1' || form.relationType=='3')"
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="form.userid"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="example-text-input" class="col-sm-12 control-label">关联手机号码
                  <span class="input-required" v-show="form.relationType=='2' || form.relationType=='3'">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="11"
                    v-model="form.phone"
                    :disabled="!(form.relationType=='2' || form.relationType=='3')"
                  />
                </div>
              </div>
              <!-- <div class="form-group form-group-50" v-show="edit==''">
                <label     class="col-sm-12 control-label">启用时间</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    placeholder
                    maxlength="30"
                    v-model="bindTime"
                    disabled
                  />
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button
              type="button"
              class="btn btn-sm btn-primary btn-sm-h"
              @click="submit()"
            >保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import all from "./carportUserAll";
import white from "./whiteList";
import cardUser from '../../management/card/carportlist'
import ontimeUser from '../../management/user/carportApproachTimeUser'

export default {
  name: "index",
  data() {
    return {
      oldBis: [
        {
          BIS_NAME: "全部用户",
          BIS_TYPE: 1,
          SHOW_TAB: Util.isPageTabsPerm("carportUserAll")
        },
        {
          BIS_NAME: "白名单用户",
          BIS_TYPE: 2,
          SHOW_TAB: Util.isPageTabsPerm("carportUserWhite")
        },
        {
          BIS_NAME: "持卡用户",
          BIS_TYPE: 3,
          SHOW_TAB: true
        },
        {
          BIS_NAME: "购包用户",
          BIS_TYPE: 4,
          SHOW_TAB: true
        }
      ],
      bis: [],
      bisType: 1,
      edit: "",
      form: {
        mobilePhone: "",
        userCard: "",
        type: "",
        state: "",
        phone: "",
        cardNo: "",
        remark: "",
        id: "",
        state: "",
        userid: "",
        relationType: ""
      },
      addTypeList: [
        {
          value: "1",
          label: "手机号码"
        },
        {
          value: "2",
          label: "手机号码 + 实体卡号"
        }
      ],
      typeList: [
        {
          value: 1,
          label: "用户ID"
        },
        {
          value: 2,
          label: "手机号码"
        },
        {
          value: 3,
          label: "用户ID + 手机号码"
        }
      ],
      userNum: {},
      newUserArr: [],
      buyUserArr: [],
      totalUserArr: [],
      arpuIncomeArr: [],
      isAllPageTabs: Util.isPageTabsPerm("carportUserAll"),
      isWhitePageTabs: Util.isPageTabsPerm("carportUserWhite"),
      addBtn: Util.isHavePerm("user/insertOrdinaryUser")
    };
  },
  components: {
    all,
    white,
    cardUser,
    ontimeUser
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getUserNum();
          this.$refs.all.getList();
          this.$refs.white.getList();
          this.$refs.cardUser.getList();
          this.$refs.ontimeUser.getList();
        }
      },
      immediate: true,
      deep: true
    },
    "form.cardNo"(val, oldVal) {
      this.form.cardNo = Util.isNumber(val);
    },
    "form.phone"(val, oldVal) {
      this.form.phone = Util.isNumber(val);
    },
    "form.userid"(val, oldVal) {
      this.form.userid = Util.isNumber(val);
      this.form = Object.assign({}, this.form);
    },
    "form.mobilePhone"(val, oldVal) {
      this.form.mobilePhone = Util.isNumber(val);
    },
    "form.userCard"(val, oldVal) {
      this.form.userCard = Util.isNumber(val);
    },
    "form.type"(val, oldVal) {
      if (val == "1") {
        this.form.userCard = "";
      }
    }
  },
  mounted() {
    this.oldBis.find(item => {
      if (item.SHOW_TAB) {
        this.bis.push(item);
      }
    });
    if (this.params.val) {
      this.key = this.searchKye;
    }
    this.getUserNum();
  },
  methods: {
    getUserNum() {
      this.$http
        .get(
          `${Util.searchURL}/Carport/GetUserInfo/${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(res => {
          if (res.data.code === 200) {
            this.userNum = res.data.data;
            this.newUserArr = [];
            this.buyUserArr = [];
            this.totalUserArr = [];
            this.arpuIncomeArr = [];
            if (res.data.data) {
              let log = res.data.data.log;
              log.find(d => {
                this.newUserArr.push(Number(d.newUserNum));
                this.buyUserArr.push(Number(d.buyUserNum));
                this.totalUserArr.push(Number(d.totalUserNum));
                this.arpuIncomeArr.push(Number(d.arpuIncomeNum));
              });
              $(function() {
                Dashmix.helpers([
                  "easy-pie-chart",
                  "sparkline",
                  "datepicker",
                  "flatpickr"
                ]);
              });
            }
          }
        });
    },
    create(val, id) {
      this.edit = val;
      this.form = {};
      if (val == "user") {
        jQuery("#modal-default-normal-all-add").modal("show");
        this.form = {
          mobilePhone: "",
          userCard: "",
          type: "",
          phone: "",
          cardNo: "",
          remark: "",
          id: "",
          state: 1,
          userid: "",
          relationType: ""
        };
      }else {
        jQuery("#modal-default-normal-card").modal("show");
        this.form = {
          mobilePhone: "",
          userCard: "",
          type: "",
          phone: "",
          cardNo: "",
          remark: "",
          id: "",
          state: 1,
          userid: "",
          relationType: ""
        };
      }
    },
    submit() {
      let url = "";
      if (this.edit == "user") {
        url = `${Util.operateURL}/user/insertOrdinaryUser`;
      } else {
        url = `${Util.operateURL}/card/insertCardInfo`;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code == 200) {
            Util.message("succ", res.data.desc);
            jQuery("#modal-default-normal-all-add").modal("hide");
            jQuery("#modal-default-normal-card").modal("hide");
            this.$refs.all.getList();
            this.$refs.white.getList();
            this.$refs.cardUser.getList();
            this.$refs.ontimeUser.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    changeType() {
      if (this.form.relationType == "1") {
        this.form.phone = "";
      } else if (this.form.relationType == "2") {
        this.form.userid = "";
      }
    },
    showTab(el, type) {
      $(`.${el}`).tab("show");
      for (let i of $(`.tab-pane`)) {
        i.className = "tab-pane fade";
      }
      $(`#${el}`).tab("show");
      this.bisType = type;
      if (type == 1) {
        this.$refs.all.getList();
      } else if (type == 2) {
        this.$refs.white.getList();
      } else if (type == 3) {
        this.$refs.cardUser.getList();
      } else if (type == 4) {
        this.$refs.ontimeUser.getList();
      }
    }
  }
};
</script>